import ExpenseTrackerApp from "./Components/App/ExpenseTrackerApp";
const App = () => {
  return (
    <div className="flex justify-center transition-all p-5 dark:bg-violet-900 bg-violet-200 min-h-screen">
      <ExpenseTrackerApp />
    </div>
  );
};

export default App;
